import "./PageHeader.scss";
import logo from "../../assets/Logo/BrainFlix-logo.svg";
import icon from "../../assets/Images/Mohan-muruge.jpg";
import uploadIcon from "../../assets/Icons/upload.svg";
import { MdSearch } from "react-icons/md";
import { Link } from "react-router-dom";

function Header() {
  return (
    <header className="nav__wrapper">
      <nav className="nav">
        <Link className="site__logo" to="/">
          <img src={logo} alt="brainflix logo"></img>
        </Link>
        <div className="nav__container">
          <div className="nav__container--right">
            <MdSearch className="nav__search--icon" />
            <input
              className="nav__search"
              type="search"
              name="search"
              placeholder="search"
            ></input>
            <img
              id="icon-mobile"
              className="user-icon"
              src={icon}
              alt="user icon"
            ></img>
            <div />
          </div>
          <div className="nav__uploadBtn--container">
            <Link to="/upload" className="upload__link">
              <img
                className="nav__uploadBtn--icon"
                src={uploadIcon}
                alt="upload icon"
              ></img>
              <button className="nav__uploadBtn">UPLOAD</button>
            </Link>
          </div>
          <img
            id="icon-tablet"
            className="user-icon"
            src={icon}
            alt="user icon"
          ></img>
        </div>
      </nav>
    </header>
  );
}

export default Header;
